import $ from "jquery";
function domObserver(handlers) {
    const selectors = Object.keys(handlers);
    if (selectors.length === 0) {
        return;
    }
    const combinedSelector = selectors.join(",");
    const seen = new WeakSet();
    let scheduled = null;
    const invoke = (element)=>{
        if (seen.has(element)) {
            return;
        }
        for (const selector of selectors){
            if (element.matches(selector)) {
                seen.add(element);
                void handlers[selector](element);
                return;
            }
        }
    };
    const scanFn = (root)=>{
        if (root instanceof HTMLElement) {
            invoke(root);
        }
        root.querySelectorAll(combinedSelector).forEach((node)=>{
            if (node instanceof HTMLElement) {
                invoke(node);
            }
        });
    };
    // Performance enhancement: Debounce scan calls with setTimeout/clearTimeout
    let pendingRoots = [];
    const scan = (root)=>{
        pendingRoots.push(root);
        if (scheduled !== null) {
            clearTimeout(scheduled);
        }
        scheduled = window.setTimeout(()=>{
            // use a Set to eliminate duplicates and flatten DocumentFragments
            const uniqueRoots = new Set();
            for (const pending of pendingRoots){
                if (pending instanceof DocumentFragment) {
                    pending.childNodes.forEach((node)=>{
                        if (node instanceof HTMLElement) {
                            uniqueRoots.add(node);
                        }
                    // Optionally process nested fragments, but unlikely in typical usage
                    });
                } else {
                    uniqueRoots.add(pending);
                }
            }
            pendingRoots = [];
            for (const root of uniqueRoots){
                scanFn(root);
            }
            scheduled = null;
        }, 0);
    };
    const start = ()=>{
        scan(document);
        new MutationObserver((mutations)=>{
            for (const mutation of mutations){
                mutation.addedNodes.forEach((node)=>{
                    if (node instanceof HTMLElement || node instanceof DocumentFragment) {
                        scan(node);
                    }
                });
            }
        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    };
    if (document.body) {
        start();
    } else {
        $(start);
    }
}
export { domObserver };
